// extracted by mini-css-extract-plugin
module.exports = {"btn-disable":"_12VP1dV9JUsQoGwMOZK9lu"};